import Loader from '@/components/custom/Loader.tsx';
import { HTMLAttributeAnchorTarget } from 'react';
import { Card } from '@/components/ui/card.tsx';
import { Link, To } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';
import { Badge } from '@/components/ui';
import { cn } from '@/lib/utils';

type TProps = {
  target?: HTMLAttributeAnchorTarget;
  imageClassName?: string;
  onClick?: () => void;
  isLoading?: boolean;
  icon?: LucideIcon;
  value?: number;
  image?: string;
  label: string;
  to: To;
};

const ContentPageGroupItem = ({ to, target, label, value, onClick, isLoading, image, imageClassName = 'h-6', ...props }: TProps) => (
  <Link to={to} target={target}>
    <Card
      onClick={onClick}
      className={`
      relative 
      flex flex-col items-center justify-center gap-3 p-2
      h-32
      text-sm font-medium 
      cursor-pointer 
      hover:bg-accent hover:text-accent-foreground
      `}>
      {
        props.icon &&
        <props.icon size={40} strokeWidth={1} />
      }
      {
        image &&
        <div className='my-auto'>
          <img
            className={imageClassName}
            src={image}
            alt='' />
        </div>
      }
      <div className='space-y-1 flex flex-col justify-start items-center'>
        <span className='text-sm text-center'>
          {label}
        </span>
        {
          value !== undefined &&
          <>
            {
              isLoading
                ? <Loader />
                : <Badge
                  variant={'secondary'}
                  className={cn(
                    'pointer-events-none flex gap-1',
                    value < 0 && 'bg-transparent text-transparent',
                    value === 0 && 'bg-muted',
                    0 < value && 'bg-purple-100 text-purple-600'
                  )}>
                  <span className='font-light'>
                    En attente
                  </span>
                  <span className='font-bold'>
                    {value}
                  </span>
                </Badge>
            }
          </>
        }
      </div>
    </Card>
  </Link>
);

export default ContentPageGroupItem;
